import { useEffect, useState } from "react";

const secondsLeft = (target?: string) => {
  const time = target ? Date.parse(target) : NaN;
  return Number.isNaN(time)
    ? 0
    : Math.max(0, Math.ceil((time - Date.now()) / 1000));
};

/** Секунды до даты (ISO 8601). Считается от текущего времени, без фиксированной длительности. */
export const useCountdown = (target?: string): number => {
  const [left, setLeft] = useState(() => secondsLeft(target));

  useEffect(() => {
    setLeft(secondsLeft(target));
    if (secondsLeft(target) === 0) {
      return;
    }

    const interval = setInterval(() => {
      const next = secondsLeft(target);
      setLeft(next);
      if (next === 0) {
        clearInterval(interval);
      }
    }, 1000);

    return () => clearInterval(interval);
  }, [target]);

  return left;
};
